import { render } from "./PanicPromotion.vue?vue&type=template&id=ea8d7798"
import script from "./PanicPromotion.vue?vue&type=script&lang=js"
export * from "./PanicPromotion.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__